# GraphQL fragment to get basic info about a source

fragment SourceBasic on Source {
    id
    name
}
